export default "__VITE_ASSET__DL0vDHSX__"